import { api } from "../api";

export function carFilter() {
    return {
        makeId: null,
        modelId: null,
        motoId: null,
        models: [],
        types: [],
        categoryLevels: [],
        async getModel() {
            this.modelId = null;
            this.motoId = null;
            this.categoryLevels = [];
            this.types = [];
            this.$refs.model.innerText = 'Wird geladen ...'
            this.models = await api.post(
                'extension/module/carfilter/models',
                `makeId=${this.makeId}`
            )
            if (this.models.length) {
                this.$refs.model.innerText = 'Modell auswählen'
            }
        },
        async getMotorizari() {
            this.motoId = null;
            this.categoryLevels = [];
            this.$refs.tip.innerText = 'Wird geladen ...'

            this.types = await api.post(
                'extension/module/carfilter/types',
                `makeId=${this.makeId}&modelId=${this.modelId}`
            )
            if (this.types.length) {
                this.$refs.tip.innerText = 'Motortyp auswählen'
            }
        },
        async initFirstCategoryLevel() {
            const categories = await this.getCategoriesByType(0);
            this.categoryLevels = [{
                options: categories,
                selected: ''
            }];
        },
        async onCategorySelect(event, levelIndex) {
            const selectedId = this.categoryLevels[levelIndex].selected;
            const selectedCategory = this.categoryLevels[levelIndex].options.find((category) => category.id == selectedId);

            if (selectedCategory.hasChilds) {
                this.categoryLevels = this.categoryLevels.slice(0, levelIndex + 1);

                if (!selectedId) return;

                const children = await this.getCategoriesByType(selectedId);

                if (children.length > 0) {
                    this.categoryLevels.push({
                        options: children,
                        selected: ''
                    });
                }
            } else {
                window.location.href = selectedCategory.href
            }
        },
        async getCategoriesByType(parentCategoryId = 0) {
            const make = this.getSelectedValueForId('marca');
            const model = this.getSelectedValueForId('model');
            const tip = this.getSelectedValueForId('tip');

            return await api.post(
                'extension/module/carfilter/categoriesByType',
                `typeId=${this.motoId}&parentCategoryId=${parentCategoryId}&make=${make}&model=${model}&typeName=${tip}`)
        },
        getSelectedValueForId(elementId) {
            const makeSelect = document.getElementById(elementId)
            return makeSelect.options[makeSelect.selectedIndex].text;
        }
    }
}